import React from "react";
import Bs from "./_bs";

export default function _placeholder(props) {
  const { line } = props;
  return (
    <>
      <Bs placeholder as="p" animation="glow">
        {line && (
          <>
            {line.map((i) => (
              <>
                <Bs row>
                  {i.itms.map((x) => (
                    <Bs col xs={x.size}>
                      <Bs placeholder xs={12} />
                    </Bs>
                  ))}
                </Bs>
              </>
            ))}
          </>
        )}
        {!line && <Bs placeholder xs={6} />}
      </Bs>
    </>
  );
}
